import { useEffect } from "react";

const useOnClickOutside = (ref, handler, optionalRef = null) => {
  useEffect(() => {
    const listener = (event) => {
      // Do nothing if clicking ref's element or descendent elements
      if (optionalRef) {
        if (
          !ref.current ||
          ref.current.contains(event.target) ||
          !optionalRef?.current ||
          optionalRef?.current.contains(event.target)
        ) {
          return;
        }
      }
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      handler(event);
    };
    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);
    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, handler]);
};

export default useOnClickOutside;
